export class UserStatus {
  constructor(id, type, status) {
    this.id = id;
    this.type = type;
    this.status = status;
  }
}
